"use client";

import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";

import {
  LayoutDashboard,
  BanknoteArrowUp,
  ListCheck,
  BanknoteArrowDown,
  Fuel,
  Car,
  Smartphone,
  User,
  ListIcon,
  Route,
  SquarePercent,
  Calendar,
  Receipt,
  ChartArea,
  Box,
  GitBranch,
  Wrench,
  Store,
} from "lucide-react";
import { useTranslate } from "react-admin";
import { NavLink, useLocation } from "react-router-dom";

export function AutoService() {
  const location = useLocation();

  const translate = useTranslate();

  const data = {
    dispatch: {
      title: "Overview",
      navs: [
        {
          name: "Dashboard",
          url: "/",
          icon: LayoutDashboard,
        },
        {
            name: translate(`report.name`, {smart_count: 2}),
            url: "/reports",
            icon: ChartArea
        },
        {
            name: translate(`reservations.name`, { smart_count: 2 }),
            url: "/reservation",
            icon: Calendar,
        },
        {
          name: translate(`invoice.name`, { smart_count: 2 }),
          url: "/invoices",
          icon: Receipt,
        },
        {
          name: translate(`users.name`, { smart_count: 2 }),
          url: "/users",
          icon: User
        },
        {
          name: "Vendor",
          url: "/vendors",
          icon: Store,
        },
      ],
    },
    management: {
      title: "Management",
      navs: [
        {
          name: translate(`inventory.name`, { smart_count: 2 }),
          url: "/inventory",
          icon: Box,
        },
        {
          name: translate(`branches.name`, { smart_count: 2 }),
          url: "/branches",
          icon: GitBranch,
        },
        {
          name: translate(`services.name`, { smart_count: 2 }),
          url: "/services",
          icon: Wrench,
        },
        {
          name: translate(`clients.name`, { smart_count: 2 }),
          url: "/client",
          icon: User,
        },
        {
          name: translate(`vehicle.name`, { smart_count: 2 }),
          url: "/vehicles",
          icon: Car,
        },
      ],
    },
  };

  return (
    <SidebarGroup>
      <SidebarGroupLabel>{data.dispatch.title}</SidebarGroupLabel>
      <SidebarMenu>
        {data.dispatch.navs.map((item: any) => (
          <SidebarMenuItem
            key={item.name}
            className={`${(item.url === "/" && location.pathname === "/") || item.url === "" + location.pathname ? "bg-gray-200 dark:bg-neutral-600 rounded-lg" : ""}`}
          >
            <SidebarMenuButton className="text-[15px] font-medium" asChild>
              <NavLink to={item.url}>
                                <item.icon />
                                <span>{item.name}</span>
                            </NavLink>
            </SidebarMenuButton>
          </SidebarMenuItem>
        ))}
      </SidebarMenu>
      <SidebarGroupLabel className="mt-4">
        {data.management.title}
      </SidebarGroupLabel>
      <SidebarMenu>
        {data.management.navs.map((item: any) => (
          <SidebarMenuItem
            key={item.name}
            className={`${item.url == "" + location.pathname ? "bg-gray-200 dark:bg-neutral-600 rounded-lg" : ""}`}
          >
            <SidebarMenuButton className="text-[15px] font-medium" asChild>
              <NavLink to={item.url}>
                                <item.icon />
                                <span>{item.name}</span>
                            </NavLink>
            </SidebarMenuButton>
          </SidebarMenuItem>
        ))}
      </SidebarMenu>
    </SidebarGroup>
  );
}
